// extracted by extract-css-chunks-webpack-plugin
module.exports = {"RefreshButton":"RefreshButton_MDdXp_v16-5-1","spin":"spin_3Qnn4_v16-5-1","disabled":"disabled_1W0Xg_v16-5-1"};